import api from './axios';

export const adminAPI = {
  // Login
  login: async (credentials) => {
    const response = await api.post('/admin/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  // Forgot Password - Send OTP
  forgotPassword: async (email) => {
    const response = await api.post('/admin/forgot-password', { email });
    return response.data;
  },

  // Verify Password Reset OTP
  verifyResetOTP: async (email, otp) => {
    const response = await api.post('/admin/verify-reset-otp', { email, otp });
    return response.data;
  },

  // Reset Password
  resetPassword: async (email, resetToken, newPassword) => {
    const response = await api.post('/admin/reset-password', {
      email,
      resetToken,
      newPassword,
    });
    return response.data;
  },

  // Dashboard Stats
  getDashboardStats: async () => {
    const response = await api.get('/admin/dashboard/stats');
    return response.data;
  },

  // Get all athletes with filters
  getAllAthletes: async (filters) => {
    const params = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params[key] = filters[key];
    });
    const response = await api.get('/admin/athletes', { params });
    return response.data;
  },

  // Get athlete details
  getAthleteDetails: async (athleteId) => {
    const response = await api.get(`/admin/athletes/${athleteId}`);
    return response.data;
  },

  // Update athlete details
  updateAthleteDetails: async (athleteId, data) => {
    const response = await api.put(`/admin/athletes/${athleteId}`, data);
    return response.data;
  },

  // Verify athlete
  verifyAthlete: async (athleteId, data) => {
    const response = await api.put(`/admin/athletes/${athleteId}/verify`, data);
    return response.data;
  },

  // Bulk verify athletes
  bulkVerifyAthletes: async (data) => {
    const response = await api.post('/admin/athletes/bulk-verify', data);
    return response.data;
  },

  // Get pending verifications
  getPendingVerifications: async (filters) => {
    const params = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params[key] = filters[key];
    });
    const response = await api.get('/admin/pending-verifications', { params });
    return response.data;
  },

  // Update medical age
  updateMedicalAge: async (athleteId, data) => {
    const response = await api.patch(`/admin/athletes/${athleteId}/medical-age`, data);
    return response.data;
  },

  // Get athletes by event
  getAthletesByEvent: async () => {
    const response = await api.get('/admin/athletes/by-event');
    return response.data;
  },

  // Delete athlete
  deleteAthlete: async (athleteId) => {
    const response = await api.delete(`/admin/athletes/${athleteId}`);
    return response.data;
  },

  // Bulk delete athletes
  bulkDeleteAthletes: async (athleteIds) => {
    const response = await api.post('/admin/athletes/bulk-delete', { athleteIds });
    return response.data;
  },
};